import { render, staticRenderFns } from "./HoriVerSrcollIcon.vue?vue&type=template&id=22f0c8a1&"
import script from "./HoriVerSrcollIcon.vue?vue&type=script&lang=js&"
export * from "./HoriVerSrcollIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports